import { render, staticRenderFns } from "./radioDesignRightsDialog.vue?vue&type=template&id=f131cdee&scoped=true"
import script from "./radioDesignRightsDialog.vue?vue&type=script&lang=js"
export * from "./radioDesignRightsDialog.vue?vue&type=script&lang=js"
import style0 from "./radioDesignRightsDialog.vue?vue&type=style&index=0&id=f131cdee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f131cdee",
  null
  
)

export default component.exports